export default [
  {
    path: '/apps/gerenciar-modulos',
    name: 'gerenciar-modulos',
    component: () => import('@/views/app/Sistema/GerenciarModulos/Index.vue'),
    meta: {
      pageTitle: 'Gerenciar Módulos',
      action: 'read',
      resource: 'GerenciarModulos',
    },
  },
];
